module.exports = __webpack_public_path__ + "img/disrupt.08f02624.png";